module.exports = __webpack_public_path__ + "img/za.45ff9875.svg";